import { Component, Vue, Emit, Watch ,Prop} from 'vue-property-decorator';
import { LoginUser,NotificationList ,ProducerApprovalList} from "@/types/Component";
import Popup from "@/components/Popup/Popup.vue";
import version from "../../App-version"
import NotificationModal from '@/components/Notification/NotificationModal/NotificationModal.vue';
import ProducerApprovalModal from '@/assets/common/Modal/ProducerApprovalModal/ProducerApprovalModal.vue';
import FertilizerModal from '@/assets/common/Modal/FertilizerModal/FertilizerModal.vue';
import WorkerModal from '@/assets/common/Modal/WorkerModal/WorkerModal.vue';
import AgriFieldModal from '@/assets/common/Modal/AgriFieldModal/AgriFieldModal.vue';
import CooperativePlantingModal from '@/assets/common/Modal/CooperativePlantingModal/CooperativePlantingModal.vue';
import SettingModal from '@/assets/common/Modal/SettingModal/SettingModal.vue';
import SeedlingModal from '@/assets/common/Modal/SeedlingModal/SeedlingModal.vue';
import MaterialsModal from '@/assets/common/Modal/MaterialsModal/MaterialsModal.vue';
import MachinesModal from '@/assets/common/Modal/MachinesModal/MachinesModal.vue';
import ProducerRegistrationModal from '@/assets/common/Modal/ProducerRegistrationModal/ProducerRegistrationModal.vue';
import AboutUseModal from '@/assets/common/Modal/AboutUseModal/AboutUseModal.vue';
import WorkItemsModal from '@/assets/common/Modal/WorkItemsModal/WorkItemsModal.vue';
import HarvestShippingModal from '@/assets/common/Modal/HarvestShippingModal/HarvestShippingModal.vue';
import WarehousesModal from '@/assets/common/Modal/WarehousesModal/WarehousesModal.vue';
import ChemicalPointListModal from '@/assets/common/Modal/ChemicalPointListModal/ChemicalPointListModal.vue';
import PwdVerifyModal from '@/assets/common/Modal/PwdVerifyModal/PwdVerifyModal.vue';
import PwdRegisterModal from '@/assets/common/Modal/PwdRegisterModal/PwdRegisterModal.vue';

interface ModalState {
  showNotificationModal: boolean
  showFertilizerModal: boolean
  showWorkerModal: boolean
  showWorkItemsModal: boolean
  showMachinesModal: boolean
  showHarvestShippingModal: boolean
  showAgriFieldModal: boolean
  showCooperativePlantingModal: boolean
  showSeedlingModal: boolean
  showMaterialsModal: boolean
  showWarehousesModal: boolean
  showSettingModal: boolean
  showProducerRegistrationModal: boolean
  isShowProducerApprovalModal:boolean
  showPwdVerifyModal: boolean
  showPwdRegisterModal: boolean
}

@Component({
  components: {
    Popup,
    NotificationModal,
    FertilizerModal,
    WorkerModal,
    ProducerRegistrationModal,
    SeedlingModal,
    SettingModal,
    AboutUseModal,
    ProducerApprovalModal,
    AgriFieldModal,
    CooperativePlantingModal,
    WorkItemsModal,
    HarvestShippingModal,
    MaterialsModal,
    WarehousesModal,
    MachinesModal,
    ChemicalPointListModal,
    PwdVerifyModal,
    PwdRegisterModal
  }
})

export default class Header extends Vue {

  @Prop() 
  isHeaderModalOpen!: boolean

  private isOpen = false;
  private isExpenditureOpen = false;
  private isSalesResultOpen = false;
  private isPesticideNavigatorOpen = false;
  private isHarvestResultOpen = false;
  private isCollectiveRegisterOpen = false;
  private isWorkResultOpen = false;
  private isAggregationOpen = false;
  private isRecordOpen = false;
  private isManagementOpen = false;
  private isMasterMenuVisible = false;
  private isAccountMenuVisible = false;
  private isNotificationAdmin = false;
  private deleteTenantAlertPopup = false;
  private notifications: NotificationList[] = []
  private producerApprovals: ProducerApprovalList[] = []
  private producerRefereshFlag = false
  notificationUnReadIconCount = 0
  producerApprovalCount = 0
  private openModalCount = 0
  /*テナント名の変更モーダル*/
  showChangeTenantPopup = false;
  private selectedTenant = {
    id:"",
    tenantName:"",
    subscriptionId:""
  };
  private showTenantName = '';
  private placeholder = "";
  get isAdmin(): boolean {
    this.notificationAdmin()
    return this.loginUser.role.find((r: string) => {
      return r === 'ADMIN'
    }) !== undefined;
  }

  get isContractAdmin(): boolean {
    return this.loginUser.role.find((r: string) => {
      return r === 'CONTRACT_ADMIN'
    }) !== undefined;
  }

  notificationAdmin() {
    this.isNotificationAdmin = this.loginUser.notificationWokerAdmin;
  }

  get isPesticidePlan() : boolean {
    return this.loginUser.isPesticidePlan;
  }

  get pesticidePlanProducer() : boolean {
    return this.loginUser.pesticidePlanProducer;
  }


  showNotificationModal=false;
  isShowProducerApprovalModal=false;
  showAboutUseModal = false;
  showFertilizerModal=false;
  showMachinesModal=false;
  showWorkerModal=false;
  showWorkItemsModal=false;
  showHarvestShippingModal=false;
  showAgriFieldModal=false;
  showCooperativePlantingModal=false;
  showSeedlingModal=false;
  showMaterialsModal=false;
  showProducerRegistrationModal=false;
  private hasHandledNotificationOnce = false;
  showCultivationModal=false;
  showSettingModal = false;
  showWarehousesModal = false;
  showChemicalPointListModal = false;
  showPwdVerifyModal = false;
  showPwdRegisterModal = false;
  private currentProducerApprovalIndex = 0;
  private siteVersion = version; //for version implementation
  private tenantVersion = "WEB"; //for version implementation
  private accountManagerUrl = process.env.VUE_APP_ACCOUNT_MANAGER_URL
  private subsriberDashboardUrl = `${this.accountManagerUrl}/subscriptions/${this.selectedTenant.subscriptionId}?type=general`
  
  get loginUser(): LoginUser {
    return this.$store.getters.loginUser;
  }

  mounted() {
    this.globalNaviOpenModal(4);
    this.globalNaviOpenModal(8);
    this.$watch('$store.getters.loginUser', this.handleDefaultTenant, { immediate: true });    
    this.$watch('$store.getters.deleteTenantAlertPopUp', this.callTenantAlertPopup, { immediate: true });
    if(this.isContractAdmin){
    this.$watch('$store.getters.producerApprovalCount', this.producerApprovalPopup, { immediate: true }); 
    }else{
      this.handleNotification(); 
    }
  }

  @Watch('isShowProducerApprovalModal')
  triggerNotification() {
  if (!this.isShowProducerApprovalModal && !this.hasHandledNotificationOnce) {
    this.hasHandledNotificationOnce = true;
    this.handleNotification(); 
  }
  if (!this.isShowProducerApprovalModal && this.producerRefereshFlag){
    this.producerApprovalPopup('')
  }
}
  
  callTenantAlertPopup() {
    this.deleteTenantAlertPopup = this.$store.getters.deleteTenantAlertPopUp
  }

  handleDefaultTenant() {
    const defaultTenant = this.$store.getters.loginUser.tenantDetailsList.find(
      (item:any) => this.$store.getters.loginUser.webDefaultTenantID === item.id
    );
    if (defaultTenant) {
      this.showTenantName = defaultTenant.tenantName;
      this.selectedTenant = { id: defaultTenant.id, tenantName: defaultTenant.tenantName ,subscriptionId:defaultTenant.subscriptionId};
    } else {
      const firstTenant = this.$store.getters.loginUser.tenantDetailsList[0];
      this.showTenantName = firstTenant.tenantName;
      this.selectedTenant = { id: firstTenant.id, tenantName: firstTenant.tenantName ,subscriptionId:firstTenant.subscriptionId};
    }
    this.subsriberDashboardUrl = `${this.accountManagerUrl}/subscriptions/${this.selectedTenant.subscriptionId}?type=general`
    this.$store.dispatch('doUpdateLastTenantId', this.selectedTenant.id);
  }

  

  get parentPageName(): string {
    return this.$store.getters.parentPageName;
  }

  get currentPageName(): string {
    return this.$store.getters.currentPageName;
  }

  get parentPageNames(): string[] {
    return this.$store.getters.parentPageNames;
  }

  get parentPageClass(): string {
    switch(this.parentPageName) {
      case 'マスター設定':
        return 'is_master';
      case '管理':
        return 'is_kanri';
      case '集計':
        return 'is_management';
      case 'カレンダー':
        return 'is_calendar';
      case '記録作成':
        return 'is_record';
      case 'ダッシュボード':
        return 'is_dashboard';
      case 'ユーザー一覧':
        return 'is_user';
      case 'お知らせ登録':
        return 'is-news'
      case 'お知らせ状況照会（契約者別）':
        return 'is-title-newssitu1'
      case 'お知らせ状況照会（お知らせ別）':
        return 'is-title-newssitu2'
      case '便利な機能':
        return 'is_benri';
      case  'ベジパレットコネクト':
        return 'is_nouyakunavi'; 
      default:
        return 'is_master';
    }
  }

  globalNaviOpen(): void {
    this.isOpen = !this.isOpen;
  }

  globalNaviClose(): void {
    this.isOpen = false;
  }

  masterMenuClose(): void {
    this.isMasterMenuVisible = false;
  }

  logout(): void {
    localStorage.clear();
    sessionStorage.clear();
    //clear vuex store state
    this.$store.replaceState({
      accsessToken: null,
      loginUser: null,
      tenantId: null,
      currentPageName: null,
      parentPageName: null,
      parentPageNames: [],
      calendarFilter: null,
      isInputChanged: false,
      isTenantChanged: false,
      notificationCount: null,
      producerApprovalCount: null,
      deleteTenantAlertPopUp: false,
      reloadFromHeader: false
    });
    location.href = "/oauth2/logout"
  }

  @Emit()
  cancel(){
    this.showChangeTenantPopup = false
  }
  
  private handleSelectChange(messageFlag:boolean){
    this.isAccountMenuVisible = false
    let result= false;
    setTimeout(()=>{
      if(messageFlag == false){
        result = window.confirm("テナントを変更します。よろしいですか。")
        this.$store.dispatch('doUpdateReloadFromHeader', true);
      }
      if(result || messageFlag == true){
        const params = {
          id:this.selectedTenant.id,
          kind:this.tenantVersion,
        }
        this.$apiClient.doRequest("post", "/profile", params).then((res) => {
          this.$store.dispatch('doUpdateIsTenantChanged', true);
          this.$store.dispatch('doUpdateLastTenantId', this.selectedTenant.id);
          return window.location.href=`/tenants/${this.selectedTenant.id}/`
        })
        .catch(() => {
          this.$toasted.error('変更に失敗しました。')
        })
      }else{
        this.$store.getters.loginUser.tenantDetailsList.map((item:any)=>{
          if(item.id == this.$store.getters.tenantId){
            this.showTenantName = item.tenantName
            this.selectedTenant = {id : item.id ,tenantName:item.tenantName ,subscriptionId :item.subscriptionId}
          }
        })
      }
    },100)
  }

  private updateTenantName(){
    if(this.showTenantName && this.showTenantName.trim() !== ''){
      const params = {
        id:this.selectedTenant.id,
        tenantName: this.showTenantName,
      }
      return this.$apiClient.doRequest("put", "/profile", params).then((res) => {
        this.$apiClient.getUserProfile()
        res.id ? this.$toasted.success('変更を保存しました。') : this.$toasted.error(res.statusMessage)
        this.cancel()
      })
      .catch(() => {
        this.$toasted.error('変更に失敗しました。')
      })
    }
    window.confirm("テナント名が必須です。")
  }
  
  globalNaviOpenModal(action: number): void {
    this.isOpen = false;
    switch (action) {
      case 0:
        this.isExpenditureOpen = !this.isExpenditureOpen;
        break
      case 1:
        this.isSalesResultOpen = !this.isSalesResultOpen;
        break
      case 2:
        this.isHarvestResultOpen = !this.isHarvestResultOpen;
        break
      case 3:
        this.isWorkResultOpen = !this.isWorkResultOpen;
        break
      case 4:
        this.isRecordOpen = !this.isRecordOpen;
        break
      case 5:
        this.isManagementOpen = !this.isManagementOpen;
        break
      case 6:
        this.isCollectiveRegisterOpen = !this.isCollectiveRegisterOpen;
        break
      case 7:
        this.isAggregationOpen = !this.isAggregationOpen;
        break
      case 8:
        this.isPesticideNavigatorOpen = !this.isPesticideNavigatorOpen;
        break
    }
  }

  handleNotification() {
    if (this.$store.getters.deleteTenantAlertPopUp == false) {
      this.$apiClient.doRequest('get',`/notifications?is_important=false`).then(res => {
        this.notifications = res.notifications
        const notiticationUnReadCount = this.notifications.filter((notification:any) => !notification.isRead).length;
        this.$store.dispatch('doUpdateNotificationCount',notiticationUnReadCount);
        this.notificationUnReadIconCount = this.$store.getters.notificationCount;
        if (this.notifications.filter((notification:any) => notification.isImportant && !notification.isRead).length) {
          this.openModal('showNotificationModal');
        }
      })
    }
  }

  producerApprovalPopup(action:string){
    if (this.$store.getters.tenantId && this.$store.getters.accsessToken) 
    this.$apiClient.doRequest('get',`/producer_approval`).then(res => {
      if (action === 'icon-click') {
      this.hasHandledNotificationOnce = true
      this.producerApprovals = res.producerApprovals;
      } else {
      this.producerApprovals = res.producerApprovals.filter((producer: any) => !producer.rejectionFlag);
      }
       const producerApprovalCount = res.producerApprovals.length ?? 0;
       this.currentProducerApprovalIndex = 0;
        this.$store.dispatch('doUpdateProducerApprovalCount',producerApprovalCount);
        this.producerApprovalCount = this.$store.getters.producerApprovalCount;
      if(this.producerApprovals.length > 0){
        this.openModal('isShowProducerApprovalModal');
      }
      else if(!this.producerRefereshFlag){
        this.handleNotification()
      }
    })
  }

  onResponded() {
      this.currentProducerApprovalIndex++;
      if (this.currentProducerApprovalIndex < this.producerApprovals.length) {
        this.openModal('isShowProducerApprovalModal');
      } else {
        this.closeModal();
      }
  }

  closeModal() {
    this.isShowProducerApprovalModal = false;
  }

  openShowAboutUseModal(): void {
    this.showAboutUseModal = true
    this.$emit('update-inert', true)
  }
  openChemicalPointListModal(): void {
    this.showChemicalPointListModal = true
    this.$emit('update-inert', true)
  }

  openModal(modalName: keyof ModalState): void {
    this.isOpen = false;
    (this as ModalState)[modalName] = true
    this.$emit('update-inert', true)
  }

  forwardInert(value: boolean) {
    this.$emit('update-inert', value)
  }

  isPathActive(path:string) {
    return this.$route.path === path;
  }

  handleClick() {
    this.$store.dispatch('doUpdateReloadFromHeader', true).then(() => {
      if(this.$store.getters.isInputChanged==false){
        location.reload();
      }else{
      const result = window.confirm('変更内容を破棄します。よろしいですか。');
        if (!result) {
            return false;
        } else {
          location.reload();  
        }
      }
    });
  }

  private async tenantSwitchLogout () {
    window.alert("ログアウトします。");
    return this.logout();
  }

  openSettingScreen(): void {
    this.isOpen = false;
    this.$apiClient.doRequest('get', '/pwd_settings').then((res: any) => {
      if (res.result) {
        this.openModal('showPwdVerifyModal');
      } else {
        this.openModal('showPwdRegisterModal');
      }
    });
  }

  onPwdVerified(): void {
    this.showPwdVerifyModal = false;
    this.openModal('showSettingModal');
  }

  onPwdRegistered(): void {
    this.showPwdRegisterModal = false;
    this.openModal('showSettingModal');
  }

}
